import React, { useState, useEffect } from 'react';

import { connect } from 'react-redux';
import classnames from 'classnames';

import { roundSelect } from '~/store/actions/round';

import './index.scss';

const HeaderCategory = ({rounds, round, categories, dispatch, colors}) => {
  const [ isOpen, setIsOpen ] = useState(false);

  const closePopper = () => setIsOpen(false);

  const onCategorySelect = (categoryName) => {
    setIsOpen(false);
    const newSelectedRound = rounds.find((item) => item.name === round.name && item.categoryName === categoryName);
    dispatch(
        roundSelect(newSelectedRound, categories)
    );
  };

  const ignoreEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    window.addEventListener('mouseup', closePopper, false);
    window.addEventListener('touchstart', closePopper, false);

    return () => {
      window.removeEventListener('mouseup', closePopper, false);
      window.removeEventListener('touchstart', closePopper, false);
    };
  });

  return (
    <div
      className="header-category"
      onClick={() => setIsOpen(!isOpen)}
      onMouseUp={ignoreEvent}
      onTouchStart={ignoreEvent}
    >
      <div className="categories-dropdown">
        <span>{round.categoryName}</span>
        <i className="fa fa-arrow-down"></i>
      </div>
      <div className={classnames('categories-popper', { show: isOpen })}>
        <ul>
          {categories.map((category, i) => {
            const active = category === round.categoryName;
            return (
              <li
                key={`header_category_item_${i}`}
                onClick={() => onCategorySelect(category)}
                className={classnames({ active })}
                style={active ? colors.active : {}}
              >
                {category}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default connect(
  null,
)(HeaderCategory);



// WEBPACK FOOTER //
// ./src/views/Home/header/HeaderCategory/index.js